import React, { useState, useEffect } from "react";
import { Col, Row, Typography, } from 'witmeg-ui-system'
import { useHistory } from 'react-router'
import "./VoucherDefaultOrderPage.scss"
import { useSelector, useDispatch } from 'react-redux';
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import { getCartItemsToCart, getFloorDetails, placeOrder } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import { Select } from "antd";
import { setOrderData, setOrderEmpty } from "../../../../../../../redux/resturantWidgetSlice";
import locationIC from "../../assets/location.svg"
import arrow from "../../assets/images/down-arrow.svg"
import cardIc from "../../assets/card.svg"
import cashIc from "../../assets/cash.svg"
import cartIc from "../../assets/cart-gray.svg"
import { getRestaurantMenuSettingsData } from "../../../../../utilities/apiRequests/neutriPosServerRequests";
import { sendPaymentDetails } from "../../../RestaurantWidget/utilities/api/paymentService";
import VoucherDefaultPaymentContainer from "../VoucherDefaultPayment/VoucherDefaultPaymentContainer";
import Footer from "../../components/Footer/Footer";
import { parsePhoneNumberWithError } from 'libphonenumber-js';
import IMAGE_PLACEHOLDER from '../../assets/images/Images/vouchers-placeholder.jpg'

const VoucherDefaultOrderSummaryPage = () => {
    const restaurantDataState = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const customerDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)) : {}
    const defaultDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
    const [isLoading, setIsLoading] = useState("")
    const [isCollapsed, setIsCollapsed] = useState("closed")
    const [isPaymentLoading, setIsPaymentLoading] = useState(false)


    const dispatch = useDispatch()
    let history = useHistory();
    const search = history.location.search;
    const params = new URLSearchParams(search);
    const redirectResult = params.get('redirectResult');

    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;
    const orderID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : ""
    const storeOrderLocalData = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)) : null

    useEffect(() => {
        if (redirectResult) {
            sendPaymentDetailsRedirect()
        }
    }, [])
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const getPrice = (
        basePrice
    ) => {
        let priceValue;
        switch (restaurantDataState.orderDetails.FulfillmentType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = basePrice.Delivery.FormattedText;
                break;
            case "DINE_IN":
                priceValue = basePrice.DineIn.FormattedText;
                break;
            case "TAKE_AWAY":
                priceValue = basePrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = basePrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }

    const renderModifierGroups = (selectedGroup) => {
        return (
            <div>
                <span>{selectedGroup.Title} ({selectedGroup.Quantity.Amount})</span>
                {selectedGroup.SelectedItems.map((selectedItem, index) => (
                    <span key={index}>
                        <span className="addon-title">
                            {selectedItem.Title} ({getPrice(selectedItem.PriceInfo.BaseTotalPrice)})
                        </span>
                        {selectedItem.SelectedModifierGroups && selectedItem.SelectedModifierGroups.length > 0 && (
                            <span>
                                {selectedItem.SelectedModifierGroups.map((nestedGroup, nestedIndex) => (
                                    <span key={nestedIndex}> {renderModifierGroups(nestedGroup)}</span>
                                ))}
                            </span>
                        )}
                        {index < selectedGroup.SelectedItems.length - 1 && <span>, </span>}
                    </span>
                ))}
            </div>
        );
    };

    const sendPaymentDetailsRedirect = () => {
        const paymentDetailsRequest = {
            cloudLocationID: storeOrderLocalData.cloudLocationID,
            reference: `Online-${storeOrderLocalData.cloudLocationID}-Ecom-${orderID}`,
            siteTransactionRef: orderID,
            store: `Ecommerce_${storeOrderLocalData.cloudLocationID}`,
            countryCode: "GB",
            paymentDetailInput: {
                redirectResult: redirectResult

            },
            shopperReference: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),

        }
        setIsPaymentLoading(true)
        sendPaymentDetails(paymentDetailsRequest, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {
            if (response) {
                if (response.resultCode && response.resultCode === "Authorised") {
                    const oid = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID)
                    history.push(`/order/success/${oid}`)
                    dispatch(setOrderEmpty())
                    setIsPaymentLoading(false)

                } else {
                    history.push(`/order/failed`)
                }
            } else {
                history.push(`/order/failed`)
            }
        })

    }
    const placeCartOrder = (type) => {
        if (restaurantDataState.orderCartData.Items.length > 0) {
            setIsPaymentLoading(true)
            let customerData = [{ ...restaurantDataState.orderDetails.Customers[0], ...customerDetails }]
            let data = { ...restaurantDataState.orderDetails, PaymentType: type, OrderType: "VOUCHER", Customers: customerData, }
            placeOrder(data).then((response) => {
                if (response) {
                    const oid = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID)
                    history.push(`/order/success/${oid}`)
                    dispatch(setOrderEmpty())
                    setIsPaymentLoading(false)

                }
            }).catch((error) => {
                history.push(`/order/failed`)
            })

        }
    }
    return (
        <div className='VoucherDefaultOrderPage '>
            {isPaymentLoading &&
                <div className="overlayer" ><div className="order-placing">Please wait your order in progress ...</div></div>
            }
            <div className="Order-confirmation">
                <div className="Order-confirmation-header">
                    <div className="header-text-cont">Checkout</div>

                </div>
                <div className="Order-confirmation-inner">
                    <div className="eco-mb-16 Order-confirmation-inner-left ">

                        <div className="order-form-summary-payment">
                            <div className="order-form-container">
                                <div className="form-header-text">Payment Options</div>
                                <div className="payment-method-2">
                                    <div className="itm-cont"><img alt="" src={cardIc} /></div>
                                    Card   </div>
                                {companyDetails.PaymentIntegration && companyDetails.PaymentIntegration.
                                    IntegrationName === "Wittally" && !redirectResult && <VoucherDefaultPaymentContainer
                                        setIsPaymentLoading={setIsPaymentLoading}
                                    />}
                            </div>
                        </div>
                    </div>
                    <div className="Order-confirmation-inner-right">
                        {isCartDataAvailable ? <div className="order-form-summary">
                            <div className="order-form-container">
                                <div className="form-header-text">Order Summary</div>
                                {isCartDataAvailable ?
                                    <>
                                        <div className="header-conater"><div className="header-conater-left">
                                            <img alt="" src={cartIc} />
                                            <div className="form-header-text-cont">Cart Items</div>
                                            <div className="text-sub ">({restaurantDataState.orderCartData.Items.length}  {restaurantDataState.orderCartData.Items.length === 1 ? "item" : "items"})</div></div>
                                            <div className="header-conater-right"><img alt="" src={arrow} className={`arrow-${isCollapsed}`} onClick={() => {
                                                if (isCollapsed === "open") {
                                                    setIsCollapsed("closed")
                                                } else {
                                                    setIsCollapsed("open")
                                                }
                                            }} /></div></div>
                                        {isCollapsed === "open" && <div className="order-cart-list">
                                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.map((item, index) => {
                                                const _hasAddons = item.SelectedModifierGroups.length > 0;
                                                return (
                                                    <div className="order-cart-item" key={index}>
                                                        <div className="order-cart-item-left">
                                                            <div className="cart-item-image-cont">

                                                                <Typography
                                                                    style={{ backgroundImage: `url(${item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER})`, objectFit: item.PictureURL === "" ? "fill" : "" }}
                                                                    className="cart-item-image">
                                                                </Typography>
                                                            </div>
                                                            <div className='item-details-container-left'>
                                                                <div className='item-cart-title truncate-text'>{item.Title}</div>
                                                                <div className="modifiers-text">
                                                                    {_hasAddons && item.SelectedModifierGroups.map((selectedGroup, index) => (
                                                                        <span key={index}> {renderModifierGroups(selectedGroup)} </span>
                                                                    ))}
                                                                </div>
                                                                <div className='item-cart-price'>  {isLoading === item.ID ? <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "20px" }}>{getPrice(item.PriceInfo.TotalPrice)}XXX</div>
                                                                    : getPrice(item.PriceInfo.TotalPrice)}</div>
                                                            </div>
                                                        </div>
                                                        <div className="order-cart-item-right">
                                                            <div className="qty-container">
                                                                {item.Quantity.Amount}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>}

                                    </>
                                    :
                                    <div className="empty-cart">
                                        <div className="empty">
                                            <div className="empty-text  eco-mb-24"> No cart items</div>
                                            <div className="custom-btn-order" onClick={() => {
                                                history.push("/")
                                            }}>Continue Shopping
                                            </div>

                                        </div>
                                    </div>}

                                <div className="price-list">
                                    <div className="form-header-text">Order Total</div>
                                    <div className="price-list-inner">
                                        <div className="price-list-inner-left">Sub total</div>
                                        <div className="price-list-inner-right">    {restaurantDataState.orderDetails.Payment.
                                            PaymentDetail.OrderTotal.Net.Formatted}</div>

                                    </div>
                                    {restaurantDataState?.orderDetails?.Payment.
                                        PaymentDetail?.Fee?.Details?.map((fee, key) => {
                                            return (
                                                <div className="price-list-inner" key={key}>
                                                    <div className="price-list-inner-left">{fee.Description}</div>
                                                    <div className="price-list-inner-right">
                                                        {fee.Amount.DisplayAmount}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                </div>
                                <div className="price-list">
                                    <div className="price-list-inner-total" >
                                        <div className="total-value-text ">Total Price</div>
                                        <div className="total-value-text ">
                                            {restaurantDataState.orderDetails.Payment.
                                                PaymentDetail.OrderTotal.Gross.Formatted}
                                        </div>
                                    </div>
                                </div>
                                {redirectResult && <div className="custom-btn-order">Payment Inprocess</div>}
                            </div>
                        </div> : ""}
                    </div>
                </div>

            </div >
            <Footer />
        </div >
    )

}
export default VoucherDefaultOrderSummaryPage